import keycloakAxios from '@/services/axios';
import {Filter} from '@/types/filter';

export const findMyCompanyGroups = async (
  filter: Filter = {},
  direction: -1 | 1 | 'asc' | 'desc' = 'asc'
) => {
  const requestBody = {
    query: {
      ...filter
    },
    sort: [
      {
        key: 'title',
        direction
      }
    ]
  };

  const response = await keycloakAxios.post('company/groups/my', requestBody);

  if (response.status >= 300) {
    throw new Error(
      `Error finding company groups: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
